/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserId
 */
export interface UserId {
    /**
     * 
     * @type {number}
     * @memberof UserId
     */
    id?: number;
}

/**
 * Check if a given object implements the UserId interface.
 */
export function instanceOfUserId(value: object): value is UserId {
    return true;
}

export function UserIdFromJSON(json: any): UserId {
    return UserIdFromJSONTyped(json, false);
}

export function UserIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserId {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function UserIdToJSON(value?: UserId | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

